// Resolves a product's display text for the active language, falling back
// to Albanian (the always-populated base fields) when a translation is
// missing — same fallback chain as t() in LanguageContext.
export function localizeProduct(product, lang) {
  if (!product) return product;

  const pick = (base, en, de) => {
    const translated = lang === 'en' ? product[en] : lang === 'de' ? product[de] : null;
    return translated || product[base];
  };

  return {
    ...product,
    name: pick('name', 'name_en', 'name_de'),
    shortDescription: pick('shortDescription', 'shortDescription_en', 'shortDescription_de'),
    fullDescription: pick('fullDescription', 'fullDescription_en', 'fullDescription_de'),
    features: (lang === 'en' ? product.features_en : lang === 'de' ? product.features_de : null) || product.features,
  };
}
